import { useNode } from '@craftjs/core';
import { Stack, TextField, Typography } from '@mui/material';
import InputSettings from '@/components/editor/settings/InputSettings';
import SettingCard from '@/components/SettingCard';
import ClassSettings from './ClassSettings';
import InputIconSettings from './InputIconSettings';

const TextInputSettings = () => {
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props,
  }));

  return (
    <Stack spacing={2}>
      <SettingCard title="Clases CSS">
        <ClassSettings />
      </SettingCard>
      <InputSettings />
      <SettingCard title="Filas">
        <Stack spacing={1}>
          <Typography variant="caption" color="text.secondary">
            Filas
          </Typography>
          <TextField
            hiddenLabel
            size="small"
            type="number"
            value={props.rows || 1}
            onChange={(e) =>
              setProp((props: any) => {
                const val = parseInt(e.target.value, 10);
                props.rows = val > 0 ? val : 1;
              })
            }
            InputProps={{ inputProps: { min: 1, max: 10 } }}
          />
        </Stack>
      </SettingCard>
      <InputIconSettings />
    </Stack>
  );
};

export default TextInputSettings;
